import { useTranslation } from 'react-i18next';

export default function AboutSection() {
  const { t } = useTranslation();

  const clients = [
    { icon: 'ri-user-3-line', title: t('about.client1.title'), desc: t('about.client1.desc') },
    { icon: 'ri-briefcase-line', title: t('about.client2.title'), desc: t('about.client2.desc') },
    { icon: 'ri-building-4-line', title: t('about.client3.title'), desc: t('about.client3.desc') },
  ];

  const points = [
    t('about.point1'),
    t('about.point2'),
    t('about.point3'),
    t('about.point4'),
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-24">
          {/* Left: Image */}
          <div className="relative">
            <div className="rounded-2xl overflow-hidden w-full" style={{ height: 440 }}>
              <img
                src="https://public.readdy.ai/ai/img_res/44b8a8c1845de41ac1b316a97330907b.jpg"
                alt="Local team consultation in Yerevan"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-5 -right-5 bg-white rounded-2xl p-5 border border-gray-100 max-w-52" style={{ boxShadow: '0 4px 24px 0 rgba(0,0,0,0.07)' }}>
              <div className="flex items-center gap-3 mb-2">
                <div className="w-8 h-8 flex items-center justify-center bg-blue-50 rounded-lg">
                  <i className="ri-map-pin-2-line text-blue-600 text-lg"></i>
                </div>
                <span className="text-sm font-semibold text-gray-900">{t('about.floatLabel')}</span>
              </div>
              <p className="text-xs text-gray-500 leading-relaxed">{t('about.floatDesc')}</p>
            </div>
          </div>

          {/* Right: Content */}
          <div>
            <span className="text-xs font-semibold text-blue-600 tracking-widest uppercase mb-4 block">{t('about.badge')}</span>
            <h2 className="text-4xl font-bold text-gray-900 leading-tight mb-5" style={{ fontFamily: "'Inter', sans-serif" }}>
              {t('about.title').split('\n').map((line, i) => (
                <span key={i}>{line}{i < t('about.title').split('\n').length - 1 && <br />}</span>
              ))}
            </h2>
            <p className="text-gray-500 text-base leading-relaxed mb-4">
              {t('about.desc1')}
            </p>
            <p className="text-gray-500 text-base leading-relaxed mb-8">
              {t('about.desc2')}
            </p>
            <div className="flex flex-col gap-3.5">
              {points.map((text) => (
                <div key={text} className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                    <i className="ri-check-line text-blue-600"></i>
                  </div>
                  <span className="text-sm text-gray-600 leading-relaxed">{text}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Who We Work With */}
        <div>
          <div className="text-center mb-12">
            <span className="text-xs font-semibold text-blue-600 tracking-widest uppercase mb-3 block">{t('about.whoTitle')}</span>
            <h3 className="text-3xl font-bold text-gray-900" style={{ fontFamily: "'Inter', sans-serif" }}>
              {t('about.whoSubtitle')}
            </h3>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {clients.map((client) => (
              <div
                key={client.title}
                className="border border-gray-100 rounded-2xl p-8 bg-white hover:border-blue-200 transition-all duration-300 cursor-default"
                style={{ backgroundColor: '#FAFBFD' }}
              >
                <div className="w-12 h-12 flex items-center justify-center bg-blue-50 rounded-xl mb-5">
                  <i className={`${client.icon} text-blue-600 text-xl`}></i>
                </div>
                <h4 className="text-lg font-semibold text-gray-900 mb-3">{client.title}</h4>
                <p className="text-sm text-gray-500 leading-relaxed">{client.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
